module.exports = __webpack_public_path__ + "img/Edit_icon-icons.com_71853.f228941d.png";